import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { ChevronDown } from 'lucide-react';
export function TestimonialFooter() {
  const faqs = [{
    q: '¿Cómo recibo el ebook?',
    a: 'Inmediatamente después de tu pago — en tu correo'
  }, {
    q: '¿Necesito una app especial?',
    a: 'No — se abre en cualquier dispositivo'
  }, {
    q: '¿Funciona si tengo TDAH?',
    a: 'Fue creado pensando en eso — especialmente para ti'
  }, {
    q: '¿Y si no tengo tiempo?',
    a: 'Cada día toma 10 minutos. Fue diseñado así.'
  }, {
    q: '¿La fe es obligatoria?',
    a: 'Es parte del proceso — pero lo aplicas a tu manera'
  }, {
    q: '¿Tienen garantía?',
    a: 'Sí — 30 días, devolución completa'
  }];
  return <footer className="bg-cream-alt pt-24 pb-12" data-id="element-149">
      <div className="max-w-4xl mx-auto px-6 md:px-8" data-id="element-150">
        {/* SECCIÓN 11 | FOOTER & FAQ */}
        <FadeIn data-id="element-151">
          <div className="bg-brown text-cream-alt rounded-3xl p-8 md:p-12 shadow-xl mb-12" data-id="element-152">
            <h2 className="text-3xl font-bold mb-10 text-center text-gold" data-id="element-153">
              Preguntas frecuentes
            </h2>

            <div className="space-y-6 mb-12" data-id="element-154">
              {faqs.map((faq, index) => <div key={index} className="border-b border-cream/10 pb-4" data-id="element-155">
                  <h4 className="text-lg font-bold mb-2 text-cream" data-id="element-156">{faq.q}</h4>
                  <p className="text-cream/70" data-id="element-157">{faq.a}</p>
                </div>)}
            </div>

            <div className="text-center" data-id="element-158">
              <a href="https://caosacalma.com/cart/56509401694532:1" target="_blank" rel="noopener noreferrer" onClick={() => {
              if (typeof window.fbq === 'function') {
                window.fbq('track', 'AddToCart');
              }
            }} className="inline-block bg-gold hover:bg-gold-light text-brown-light text-lg font-bold py-4 px-10 rounded-full transition-all duration-300 shadow-lg hover:-translate-y-1 no-underline" data-id="element-159">
                💛 QUIERO MI CALMA AHORA →
              </a>
            </div>
          </div>

          <div className="text-center" data-id="element-160">
            <div className="w-12 h-px bg-brown/20 mx-auto mb-8" data-id="element-161" />
            <p className="text-sm text-brown-light/60 tracking-wider uppercase" data-id="element-162">
              De Caos a Calma &copy; {new Date().getFullYear()}
            </p>
          </div>
        </FadeIn>
      </div>
    </footer>;
}